import { useState, useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaTachometerAlt,
  FaTasks,
  FaChartBar,
  FaSignOutAlt,
  FaExclamationTriangle,
  FaPauseCircle,
  FaExchangeAlt,
  FaUserShield,
  FaBox,
  FaBoxOpen,
  FaCogs,
  FaCalculator,
  FaMoneyBillAlt,
  FaBarcode,
  FaTruck,
  FaAmazon,
  FaStore,
  FaChevronDown,
  FaChevronRight,
  FaBuilding,
  FaCalendarAlt,
  FaShoppingCart,
  FaTags,
  FaCog,
  FaNetworkWired,
  FaClock,
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { useSidebar } from "../context/SidebarContext";

const menuConfig = [
  {
    id: "company",
    label: "Company Dashboard",
    icon: FaBuilding,
    children: [
      {
        id: "company_dashboard",
        label: "Dashboard",
        to: "/company-dashboard",
        modulePermission: "AccessCompanyDashboard",
        pagePermission: "CompanyDashboard",
        icon: FaTachometerAlt,
      },
    ],
  },
  {
    id: "planning",
    label: "Planning",
    icon: FaCalendarAlt,
    children: [
      {
        id: "planning_dashboard",
        label: "Dashboard",
        to: "/dashboard",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagDashboard",
        icon: FaTachometerAlt,
      },
      {
        id: "planning_workorders",
        label: "Work Orders",
        to: "/workorder",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagWorkOrder",
        icon: FaTasks,
      },
      {
        id: "planning_alerts",
        label: "Alerts",
        to: "/alerts",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagAlerts",
        icon: FaExclamationTriangle,
      },
      {
        id: "planning_analytics",
        label: "Analytics",
        to: "/analytics",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagAnalytics",
        icon: FaChartBar,
      },
      {
        id: "planning_onhold",
        label: "On Hold",
        to: "/on-hold",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagOnHold",
        icon: FaPauseCircle,
      },
      {
        id: "planning_transfers",
        label: "Transfers",
        to: "/transfers",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagTransfers",
        icon: FaExchangeAlt,
      },
      {
        id: "planning_settings",
        label: "Settings",
        isSubCategory: true,
        icon: FaCog,
        children: [
          {
            id: "planning_settings_products",
            label: "Products Configuration",
            to: "/products",
            modulePermission: "AccessERPag",
            pagePermission: "ERPagProducts",
            icon: FaBox,
          },
          {
            id: "planning_settings_values",
            label: "Assigned Values",
            to: "/products-settings",
            modulePermission: "AccessERPag",
            pagePermission: "ERPagAssignedValues",
            icon: FaCogs,
          },
        ],
      },
    ],
  },
  {
    id: "shipping",
    label: "Shipping",
    icon: FaTruck,
    children: [
      {
        id: "weekly_planner",
        label: "Weekly Planner",
        to: "/weekly-planner",
        modulePermission: "AccessAceLynk",
        pagePermission: "ERPagCustomerShippingSchedule",
        icon: FaClock,
      }, 
      /*     
      {
        id: "shipping_schedule",
        label: "Customer Shipping Schedule",
        to: "/customer-shipping-schedule",
        modulePermission: "AccessERPag",
        pagePermission: "ERPagCustomerShippingSchedule",
        icon: FaTruck,
      },
      */
      {
        id: "shipping_acelynk",
        label: "AceLynk XML",
        to: "/acelynk",
        modulePermission: "AccessAceLynk",
        pagePermission: "AceLynkXML",
        icon: FaBoxOpen,
      },      
    ],
  },
  {
    id: "sales",
    label: "Sales",
    icon: FaShoppingCart,
    children: [    
      {
        id: "sales_analytics",
        label: "Sales Analytics",
        to: "/sales-analytics",
        modulePermission: "AccessSales",
        pagePermission: "SalesAnalytics",
        icon: FaChartBar,
      },
      {
        id: "sales_erpag",
        label: "ERPAG",
        to: "/sales-erpag",
        modulePermission: "AccessSales",
        pagePermission: "SalesERPag",
        icon: FaTachometerAlt,
      },
      {
        id: "sales_amazon",
        label: "Amazon",
        to: "/sales-amazon",
        modulePermission: "AccessSales",
        pagePermission: "SalesAmazon",
        icon: FaAmazon,
      },
      {
        id: "sales_shopify",
        label: "Shopify",
        to: "/sales-shopify",
        modulePermission: "AccessSales",
        pagePermission: "SalesShopify",
        icon: FaStore,
      },
      {
        id: "sales_walmart",
        label: "Walmart",
        to: "/sales-walmart",
        modulePermission: "AccessSales",
        pagePermission: "SalesWalmart",
        icon: FaStore,
      },

      {
        id: "admin_settings",
        label: "Admin Settings",
        to: "/admin-settings",
        modulePermission: "AccessSales",
        pagePermission: "SalesAnalytics",
        icon: FaCog,
      },
    ],
  },
  {
    id: "sku_price",
    label: "SKU & Price Management",
    icon: FaTags,
    children: [
      {
        id: "sku_pricing_tool",
        label: "SKU Creation & Pricing Tool",
        to: "/costing-tool",
        modulePermission: "AccessCosting",
        pagePermission: "CostingToolPage",
        icon: FaCalculator,
      },
      {
        id: "sku_price_management",
        label: "Price Management",
        to: "/price-management",
        modulePermission: "AccessCosting",
        pagePermission: "CostingToolPage",
        icon: FaMoneyBillAlt,
      },
       {
        id: "private_label_quotations",
        label: "Quotation Center",
        to: "/quotation-center",
        modulePermission: "AccessCosting",
        pagePermission: "CostingToolPage",
        icon: FaBox,
      },
      {
        id: "sku_barcode_center",
        label: "Barcode Center",
        to: "/generated-upcs",
        modulePermission: "AccessCosting",
        pagePermission: "CostingGeneratedUPCs",
        icon: FaBarcode,
      },
      
      {
        id: "sku_costing_settings",
        label: "Costing & BOM Settings",
        to: "/costing-settings",
        modulePermission: "AccessCosting",
        pagePermission: "CostingSettingsPage",
        icon: FaMoneyBillAlt,
      },
     
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: FaCog,
    children: [
      {
        id: "settings_permissions",
        label: "Users & Permissions",
        to: "/UserAndPermissionsManagement",
        modulePermission: "AccessUserPermissionManagement",
        pagePermission: "UsersPermissionsPage",
        icon: FaUserShield,
      },
    ],
  },
];

const Sidebar = () => {
  const { sidebarOpen, setSidebarOpen } = useSidebar();
  const location = useLocation();
  const { logout, canRead, user } = useContext(AuthContext);
  const [expandedCategories, setExpandedCategories] = useState({});

  const isWorkOrderRoute = location.pathname === "/workorder";

  const getNavLinkClass = ({ isActive }) =>
    `block py-2 px-3 rounded hover:bg-gray-800 transition text-sm text-white flex items-center space-x-2 whitespace-nowrap ${isActive ? "bg-gray-800 text-white font-medium border-l-2 border-pink-500 rounded-l-none" : ""
    }`;

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    if (window.innerWidth >= 640) {
      setSidebarOpen(!isWorkOrderRoute);
    }
  }, [isWorkOrderRoute, setSidebarOpen]);

  // Expand category if current route matches one of its children
  useEffect(() => {
    const initialExpanded = {};
    menuConfig.forEach((parent) => {
      let hasActiveChild = false;
      if (parent.children) {
        parent.children.forEach((child) => {
          if (child.isSubCategory) {
            let hasActiveSubChild = false;
            child.children.forEach((subChild) => {
              if (location.pathname === subChild.to) {
                hasActiveSubChild = true;
              }
            });
            if (hasActiveSubChild) {
              initialExpanded[child.id] = true;
              hasActiveChild = true;
            }
          } else {
            if (location.pathname === child.to) {
              hasActiveChild = true;
            }
          }
        });
      }
      if (hasActiveChild) {
        initialExpanded[parent.id] = true;
      }
    });
    setExpandedCategories((prev) => ({ ...prev, ...initialExpanded }));
  }, [location.pathname]);

  const handleNavLinkClick = () => {
    if (window.innerWidth < 640) {
      setSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    logout();
    setSidebarOpen(false);
  };

  const handleMouseEnter = () => {
    if (isWorkOrderRoute && !sidebarOpen) {
      setSidebarOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (isWorkOrderRoute && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  const toggleCategory = (categoryId) => {
    if (!sidebarOpen) {
      setSidebarOpen(true);
      setExpandedCategories((prev) => ({
        ...prev,
        [categoryId]: true,
      }));
    } else {
      setExpandedCategories((prev) => ({
        ...prev,
        [categoryId]: !prev[categoryId],
      }));
    }
  };

  // Dynamically filter menu entries by user permissions
  const filterMenu = (menu) => {
    return menu
      .map((parent) => {
        if (parent.children) {
          const filteredChildren = parent.children
            .map((child) => {
              if (child.id === "settings_permissions") {
                const isAdmin = user && user.role && user.role.toLowerCase() === "admin";
                const hasExplicitPerm = canRead(child.modulePermission) && canRead(child.pagePermission);
                if (!isAdmin && !hasExplicitPerm) {
                  return null;
                }
              }

              if (child.isSubCategory) {
                const filteredSubChildren = child.children.filter((subChild) => {
                  return canRead(subChild.modulePermission) && canRead(subChild.pagePermission);
                });
                if (filteredSubChildren.length > 0) {
                  return { ...child, children: filteredSubChildren };
                }
                return null;
              } else {
                const hasAccess = canRead(child.modulePermission) && canRead(child.pagePermission);
                return hasAccess ? child : null;
              }
            })
            .filter(Boolean);

          if (filteredChildren.length > 0) {
            return { ...parent, children: filteredChildren };
          }
          return null;
        }
        return null;
      })
      .filter(Boolean);
  };

  const filteredMenu = filterMenu(menuConfig);

  // Check if a parent contains the active route to highlight its header
  const isParentActive = (parent) => {
    let active = false;
    parent.children.forEach((child) => {
      if (child.isSubCategory) {
        child.children.forEach((subChild) => {
          if (location.pathname === subChild.to) active = true;
        });
      } else {
        if (location.pathname === child.to) active = true;
      }
    });
    return active;
  };

  return (
    <>
      <div
        className={`
          fixed z-[9999] inset-y-0 left-0 bg-black text-white p-2 sm:p-3 
          h-[100dvh] overflow-y-auto overflow-x-hidden flex flex-col transition-all duration-300
          ${sidebarOpen ? "w-72" : "w-16"}                 
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full sm:translate-x-0"}
          sm:block
        `}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <img
            src="/Logo_AffaireSpices_WhiteRegular.png"
            alt="Company Logo"
            className={`h-8 sm:h-10 w-auto ${sidebarOpen ? "block" : "hidden"}`}
          />
          <button className="sm:hidden" onClick={toggleSidebar}>
            <FaTimes className="text-white text-xl" />
          </button>
        </div>

        <nav className="space-y-1 flex-1">
          {filteredMenu.map((parent) => {
            const ParentIcon = parent.icon;
            const isExpanded = !!expandedCategories[parent.id];
            const activeParent = isParentActive(parent);

            return (
              <div key={parent.id} className="space-y-1">
                {/* Category Header */}
                <button
                  onClick={() => toggleCategory(parent.id)}
                  className={`w-full text-left py-2 px-3 rounded hover:bg-gray-800 transition flex items-center justify-between text-sm ${activeParent ? "text-white font-semibold bg-gray-900/50" : "text-gray-300"
                    }`}
                >
                  <div className="flex items-center space-x-2">
                    <ParentIcon className="text-lg flex-shrink-0" />
                    <span className={`${sidebarOpen ? "block" : "hidden"} truncate`}>
                      {parent.label}
                    </span>
                  </div>
                  {sidebarOpen && (
                    <div className="text-xs text-gray-500">
                      {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                    </div>
                  )}
                </button>

                {/* Category Children */}
                {isExpanded && sidebarOpen && (
                  <div className="pl-3 space-y-1 border-l border-gray-800 ml-3 transition-all duration-300">
                    {parent.children.map((child) => {
                      if (child.isSubCategory) {
                        const isSubExpanded = !!expandedCategories[child.id];
                        const SubIcon = child.icon || FaCog;
                        const subActive = child.children.some((sc) => location.pathname === sc.to);

                        return (
                          <div key={child.id} className="space-y-1">
                            <button
                              onClick={() => toggleCategory(child.id)}
                              className={`w-full text-left py-1.5 px-3 rounded hover:bg-gray-850 transition flex items-center justify-between text-xs ${subActive ? "text-white font-medium" : "text-gray-400"
                                }`}
                            >
                              <div className="flex items-center space-x-2 min-w-0">
                                <SubIcon className="text-sm flex-shrink-0" />
                                <span>{child.label}</span>
                              </div>
                              <div>
                                {isSubExpanded ? <FaChevronDown /> : <FaChevronRight />}
                              </div>
                            </button>
 
                            {isSubExpanded && (
                              <div className="space-y-1 pl-3">
                                {child.children.map((subChild) => {
                                  const SubChildIcon = subChild.icon;
                                  return (
                                    <NavLink
                                      key={subChild.id}
                                      to={subChild.to}
                                      className={getNavLinkClass}
                                      onClick={handleNavLinkClick}
                                    >
                                      <SubChildIcon className="text-sm flex-shrink-0" />
                                      <span>{subChild.label}</span>
                                    </NavLink>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      }
 
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.id}
                          to={child.to}
                          className={getNavLinkClass}
                          onClick={handleNavLinkClick}
                        >
                          <ChildIcon className="text-sm flex-shrink-0" />
                          <span>{child.label}</span>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        <div className="mt-4 pt-2 border-t border-gray-600 sm:mt-auto">
          <button
            onClick={handleLogout}
            className={`w-full bg-ef0db0 text-white py-2 rounded-lg hover:bg-d73094 transition duration-200 flex items-center space-x-2 text-sm ${sidebarOpen ? "px-3" : "px-3 justify-center"
              }`}
          >
            <FaSignOutAlt className="text-lg" />
            <span className={`${sidebarOpen ? "block" : "hidden"}`}>
              Logout
            </span>
          </button>
        </div>
      </div>

      <div className="fixed top-2 right-[10px] z-[99] sm:hidden">
        <button
          onClick={toggleSidebar}
          className="p-1 bg-white rounded-full w-[40px] h-[40px] flex items-center justify-center shadow-[2px_8px_16px_0px_rgba(0,0,0,0.4)]"
        >
          {sidebarOpen ? (
            <FaTimes className="text-black text-xl" />
          ) : (
            <FaBars className="text-black text-xl" />
          )}
        </button>
      </div>
    </>
  );
};

export default Sidebar;